import {EditProps} from "react-admin";
import {DefaultEdit} from "../components/DefaultEdit";
import {SubjectForm} from "./SubjectForm";

export const SubjectEdit = (props: EditProps) => {
  return (
    <DefaultEdit {...props}>
      <SubjectForm  />
    </DefaultEdit>
  );
};
